import { useQuery } from '@apollo/client'
import { Button, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import Pagination from '@material-ui/lab/Pagination'
import { matchSorter } from 'match-sorter'
import React, { useEffect, useMemo, useState } from 'react'

import PageHeader from '../../components/PageHeader'
import { PROVIDERS_QUERY } from '../../graphql/providerQueries'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { ProviderBrief } from '../../types/provider'
import ProviderFilters from './ProviderFilters'
import { ProvidersTable } from './ProviderTable'
import useStyles from './styles/index.styles'

function ProviderList() {
  const theme = useTheme()
  const classes = useStyles()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const [perPage] = useState(5)
  const [page, setPage] = React.useState(1)
  const [count, setcount] = React.useState<number>(0)
  const [searchInputValue, setsearchInputValue] = React.useState<string>('')
  const [filteredproviders, setfilteredproviders] = React.useState<
    ProviderBrief[]
  >([])
  const { data, loading, refetch } = useQuery<{
    providers: ProviderBrief[]
  }>(PROVIDERS_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    variables: {
      showLog: true
    }
  })

  useEffect(() => {
    setPage(1)
    let fullTemplatesList = data?.providers ? data?.providers : []
    const newFilteredProviders = matchSorter(
      fullTemplatesList,
      searchInputValue,
      {
        keys: ['name', 'nameFA', 'displayProviderCode']
      }
    )

    setfilteredproviders(newFilteredProviders)
    setcount(newFilteredProviders.length)
  }, [searchInputValue, loading, data])

  const numberOfPages = useMemo(() => Math.ceil(count / perPage), [count])

  // const hasAccessToChangeTenant = contractPagesProviderManagement
  //   .find((item) => item.route === '/contracts/(list|templates)')
  //   ?.sections?.TENANT_SELECTOR?.providersListWithWriteAccess.includes(
  //     getProviderFromStorage()
  //   )

  return (
    <div>
      <PageHeader title={getTranslate('Providers')} />

      <div className={classes.header}>
        <Typography variant="h3" gutterBottom>
          {getTranslate('Providers List')}
        </Typography>
        {/* {contractPagesProviderManagement
          .find((item) => item.route === '/contracts/(list|templates)')
          ?.sections?.ADD_TEMPLATE_BUTTON.providersListWithWriteAccess.includes(
            getProviderFromStorage()
          ) && ( */}
        <Button
          startIcon={<AddIcon />}
          variant="contained"
          color="primary"
          component={LocalizedLink}
          to="/provider/create">
          {getTranslate(`Add${isSmallScreen ? '' : ' Provider'}`)}
        </Button>
        {/* )} */}
      </div>
      <ProviderFilters
        // hasAccessToChangeTenant={hasAccessToChangeTenant}
        inputValue={searchInputValue}
        setinputVal={setsearchInputValue}
        loadingForDisableSearchBox={loading}
      />
      <ProvidersTable
        reloadData={refetch}
        data={filteredproviders.slice((page - 1) * perPage, page * perPage)}
        loading={loading}
      />
      <div className={classes.paginationContainer}>
        <Pagination
          count={numberOfPages}
          color="primary"
          size={isSmallScreen ? 'small' : 'medium'}
          page={page}
          onChange={(_, value) => setPage(value)}
        />
      </div>
    </div>
  )
}

export default ProviderList
